// Service del listado "Ausentes" del monitoreo de asistencia.
// GET /attendance/monitoring/absentees?companyIds=...&page=...&pageSize=...&searchText=...
// Recibe los filtros compartidos del monitoreo más paginación/búsqueda/orden
// (LC_ListMonitoringAbsenteesIn) y devuelve el listado paginado (LC_ListMonitoringAbsenteesOut).

import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import { buildQueryString } from '@/api/shared';
import type {
  LC_ListMonitoringAbsenteesIn,
  LC_ListMonitoringAbsenteesOut,
} from '../types/monitoringAbsentees.types';


export class MonitoringAbsenteesService {
  async get(
    params: LC_ListMonitoringAbsenteesIn,
    signal?: AbortSignal,
  ): Promise<ApiResponse<LC_ListMonitoringAbsenteesOut>> {
    const query = buildQueryString({ ...params });
    const endpoint = `${API_CONFIG.ENDPOINTS.MONITORING_ABSENTEES}${query}`;

    return apiClient.get<LC_ListMonitoringAbsenteesOut>(endpoint, { signal });
  }
}

export const monitoringAbsenteesService = new MonitoringAbsenteesService();
